// import { SelectItem } from '@/types';

export enum LeadsStatuses {
  /**
   * Новый
   */
  NEW = 'new',

  /**
   * В работе
   */
  IN_WORK = 'in_work',

  /**
   * Получен партнёром
   */
  RECEIVED = 'received',

  /**
   * Долгая сделка
   */
  PROTRACTED = 'protracted',

  /**
   * Консультация
   */
  CONSULTATION = 'consultation',

  /**
   * Передано
   */
  SENDED = 'sended',

  /**
   * Продажа
   */

  SALE = 'sale',

  /**
   * Отмена
   */
  CANCELED = 'canceled',

  /**
   * Дубль
   */
  DOUBLE = 'double',

  /**
   * Отказаться от обработки, вернуть в АТОЛ
   */
  REFUSE = 'refuse',

  /**
   * Консультация потенциальному клиенту
   */
  POTENTIAL_CONSULTATION = 'potential_consultation',
}

export const LeadsStatusesTranslate: Record<string, string> = {
  [LeadsStatuses.NEW]: 'Новый',
  [LeadsStatuses.IN_WORK]: 'В работе',
  [LeadsStatuses.RECEIVED]: 'Получен партнёром',
  [LeadsStatuses.PROTRACTED]: 'Долгая сделка',
  [LeadsStatuses.CONSULTATION]: 'Консультация действующему клиенту',
  [LeadsStatuses.SENDED]: 'Передано в АТОЛ Онлайн',
  [LeadsStatuses.SALE]: 'Продажа',
  [LeadsStatuses.CANCELED]: 'Отмена',
  [LeadsStatuses.DOUBLE]: 'Дубль',
  [LeadsStatuses.REFUSE]: 'Отказаться от обработки, вернуть в АТОЛ',
  [LeadsStatuses.POTENTIAL_CONSULTATION]: 'Консультация потенциальному клиенту',
};
